"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestSignatureVerifier = void 0;
var crypto_1 = require("crypto");
var url_1 = require("url");
var VERIFY_TOLERANCE = 2.5 * 60;
var RequestSignatureVerifier = /** @class */ (function () {
    function RequestSignatureVerifier(apiKey, method, url, body) {
        this.apiKey = apiKey;
        this.method = method;
        this.url = url;
        this.body = body;
    }
    RequestSignatureVerifier.prototype.generate = function (timestamp) {
        var hashString = this.getCanonicalHashString(timestamp);
        return (0, crypto_1.createHmac)('sha256', Buffer.from(this.apiKey, 'base64'))
            .update(hashString)
            .digest();
    };
    RequestSignatureVerifier.prototype.generateAuthorizationHeader = function (timestamp) {
        timestamp = timestamp !== null && timestamp !== void 0 ? timestamp : Math.floor(Date.now() / 1000);
        var signature = this.generate(timestamp).toString('base64');
        return "Signature ".concat(timestamp, ";").concat(signature);
    };
    RequestSignatureVerifier.prototype.verify = function (signature, timestamp) {
        var generated = this.generate(timestamp);
        if (signature.length !== generated.length ||
            !(0, crypto_1.timingSafeEqual)(signature, generated)) {
            throw new Error('Invalid signature');
        }
        var now = Date.now() / 1000;
        if (now < timestamp - VERIFY_TOLERANCE ||
            now > timestamp + VERIFY_TOLERANCE) {
            throw new Error('Expired signature');
        }
        return true;
    };
    RequestSignatureVerifier.prototype.getCanonicalHashString = function (timestamp) {
        var url = new url_1.URL(this.url);
        return [
            this.method,
            "".concat(url.hostname).concat(url.pathname).concat(url.search),
            timestamp,
            this.body,
        ].join('\n');
    };
    return RequestSignatureVerifier;
}());
exports.RequestSignatureVerifier = RequestSignatureVerifier;
//# sourceMappingURL=RequestSignatureVerifier.js.map